var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAlert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_error_outline_24px",
    d: "M8.3,11.1H9.7v1.4H8.3Zm0-5.6H9.7V9.7H8.3ZM8.993,2A7,7,0,1,0,16,9,7,7,0,0,0,8.993,2ZM9,14.6A5.6,5.6,0,1,1,14.6,9,5.6,5.6,0,0,1,9,14.6Z",
    transform: "translate(-2 -2)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-alert.81b7f94a345f3b2a28d6db2883e491e4.svg";